import * as types from '../router-subscriber-types';

const defaultState = {
  code: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case types.ROUTING:
      return Object.assign(
        {},
        { code: action.data.code, getState: action.data.getState }
      );
    case types.ROUTING_RESET:
    default:
      return Object.assign({}, defaultState);
  }
};

export default reducer;
